<template>
  <div class="container-sm"> 
    <HeaderComp></HeaderComp>
  </div>
</template>

<script>
import HeaderComp from './components/HeaderComp.vue'
export default {
  name: 'App',
  components:{
    HeaderComp
  }
}
</script>

<style></style>
